import { Dispatch, useCallback, useContext } from 'react';
import { useRouter } from '../../../hooks/useRouter';
import { FilterChoice } from '../types/FilterChoice';
import { makeSearchUrl } from '../urls/makeSearchUrl';
import { SearchFilterContext } from './SearchFilterContext';

export const useSearchFilters = (): [FilterChoice, Dispatch<FilterChoice>] => {
  const filters = useContext(SearchFilterContext);

  const router = useRouter();

  const setFilters = useCallback(
    (filters: FilterChoice) => {
      // Reset extra query on subsequent filter update
      const filtersWithoutExtraQuery = { ...filters, extraQuery: undefined };

      void router?.push(makeSearchUrl(filtersWithoutExtraQuery));
    },
    [router],
  );

  return [filters, setFilters];
};
